import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CostAdjustmentModel } from 'src/app/models/inventory/cost-adjustment.model';
import { CostAdjustmentPrintModel } from 'src/app/models/print/inventory/cost-adjustment-print-model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CostAdjustmentTableModel } from 'src/app/models/tables/inventory/cost-adjustment.table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CostAdjustmentService {

  constructor(private _httpClient: HttpClient) { }

  createCostAdjustment(costAdjustmentModel: CostAdjustmentModel): Observable<CostAdjustmentModel> {
    return this._httpClient.post<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.CreateCostAdjustment}`,
      costAdjustmentModel
    );
  }

  deleteCostAdjustment(costAdjustmentId: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('costAdjustmentId', costAdjustmentId);
    return this._httpClient.delete<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.DeleteCostAdjustment}`,
      { params: params }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob'
    });
  }

  getAllInventoriesForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetAllInventoriesForSelectAsync}`,);
  }

  getAllCostAdjustmentsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<CostAdjustmentTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<CostAdjustmentTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetAllCostAdjustmentsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllInventoryEntriesForSelect(providerId: number, inventoryId: number): Observable<any[]> {
    const params = new HttpParams().set('providerId', providerId).set('inventoryId', inventoryId);
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetAllInventoryEntriesForSelectAsync}`,
      { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetColumnsForGeneralConsultationAsync}`);
  }

  getCostAdjustmentById(costAdjustmentId: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('costAdjustmentId', costAdjustmentId);
    return this._httpClient.get<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetCostAdjustmentById}`,
      { params: params }
    );
  }

  getCostAdjustmentByKeys(inventoryId: number, branchId: number, consecutive: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('inventoryId', inventoryId).set('branchId', branchId).set('consecutive', consecutive)
    return this._httpClient.get<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetCostAdjustmentByKeysAsync}`,
      { params: params }
    );
  }

  getCostAdjustmentByKeysByPrint(costAdjustmentId: number, branchId: number, consecutive: number): Observable<CostAdjustmentPrintModel> {
    const params = new HttpParams().set('costAdjustmentId', costAdjustmentId).set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<CostAdjustmentPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetCostAdjustmentByKeysByPrintAsync}`,
      { params }
    );
  }

  getFirstCostAdjustmentByKeys(inventoryId: number, branchId: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('inventoryId', inventoryId).set('branchId', branchId);
    return this._httpClient.get<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetFirstCostAdjustmentByKeysAsync}`,
      { params: params }
    );
  }

  getEmptyCostAdjustmentPrint(): Observable<CostAdjustmentPrintModel> {
    return this._httpClient.get<CostAdjustmentPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetEmptyCostAdjustmentPrint}`);
  }

  getLastCostAdjustmentByKeys(inventoryId: number, branchId: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('inventoryId', inventoryId).set('branchId', branchId);
    return this._httpClient.get<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetLastCostAdjustmentByKeysAsync}`,
      { params: params }
    );
  }

  getNextCostAdjustmentByKeys(inventoryId: number, branchId: number, consecutive: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('inventoryId', inventoryId).set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetNextCostAdjustmentByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusCostAdjustmentByKeys(inventoryId: number, branchId: number, consecutive: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('inventoryId', inventoryId).set('branchId', branchId).set('consecutive', consecutive)
    return this._httpClient.get<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetPreviusCostAdjustmentByKeysAsync}`,
      { params: params }
    );
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.GetPermissionPrint}`);
  }

  setStateCostAdjustment(costAdjustmentId: number): Observable<CostAdjustmentModel> {
    const params = new HttpParams().set('costAdjustmentId', costAdjustmentId);
    return this._httpClient.put<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.SetStateCostAdjustment}`,
      null, { params: params }
    );
  }

  updateCostAdjustment(costAdjustmentContract: CostAdjustmentModel): Observable<CostAdjustmentModel> {
    return this._httpClient.put<CostAdjustmentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.costAdjustment.UpdateCostAdjustment}`,
      costAdjustmentContract
    );
  }
}
